import { appSchema, tableSchema } from "@nozbe/watermelondb"

import { highlightTable } from "./migrations/02-highlight-table"
import { progressTable } from "./migrations/03-progress-table"

export default appSchema({
  version: 3,
  tables: [tableSchema(highlightTable), tableSchema(progressTable)],
})
